import { dataHooks } from '@wix/data-hooks'

export const cardBoxDataHooks = dataHooks<{
  image: {}
  title: {}
  description: {}
  button: {}
  badge: {}
}>('card-box')
